import { _ as __decorate, a as __metadata, B as BaseComponent } from '../index-C155IGn1.js';
import { css, LitElement, nothing, html } from 'lit';
import { property, state, query } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import 'lit/directive.js';

class AriaKeyboardListController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    setConfig(config) {
        this.config = config;
    }
    hostDisconnected() {
        this.host.removeController(this);
    }
    // eslint-disable-next-line class-methods-use-this
    getActiveElement() {
        let active = document.activeElement;
        while (active && active.shadowRoot && active.shadowRoot.activeElement) {
            active = active.shadowRoot.activeElement;
        }
        return active;
    }
    handleKeyDown(event) {
        if (!this.config)
            return;
        const items = this.config.getItems();
        const currentIndex = items.indexOf(this.getActiveElement());
        switch (event.key) {
            case 'ArrowDown':
                // case 'ArrowRight':
                event.preventDefault();
                if (items.length && currentIndex < items.length - 1)
                    this.config.setActive(currentIndex < 0 ? 0 : currentIndex + 1);
                break;
            case 'ArrowUp':
                // case 'ArrowLeft':
                event.preventDefault();
                if (items.length)
                    this.config.setActive(currentIndex < 0 ? items.length - 1 : currentIndex - 1);
                break;
            case 'Home':
                event.preventDefault();
                if (items.length)
                    this.config.setActive(0);
                break;
            case 'End':
                event.preventDefault();
                if (items.length)
                    this.config.setActive(items.length - 1);
                break;
            case 'Escape':
                event.preventDefault();
                this.config.closeMenu();
                break;
        }
    }
}

var styles = css`.dropdown,
.dropdown-menu {
  --bsi-dropdown-animation-speed: var(--bsi-transition-instant);
  --bsi-dropdown-background: var(--bsi-color-background-inverse);
  --bsi-dropdown-border-color: transparent;
  --bsi-dropdown-border-radius: var(--bsi-radius-smooth);
  --bsi-dropdown-border-width: 0;
  --bsi-dropdown-box-shadow: var(--bsi-elevation-medium);
  --bsi-dropdown-color: var(--bsi-color-text-base);
  --bsi-dropdown-divider-bg: var(--bsi-color-border-subtle);
  --bsi-dropdown-divider-margin-y: var(--bsi-spacing-xxs);
  --bsi-dropdown-font-size: var(--bsi-label-font-size);
  --bsi-dropdown-header-color: var(--bsi-color-text-secondary);
  --bsi-dropdown-header-font-size: var(--bsi-label-font-size);
  --bsi-dropdown-header-padding-x: var(--bsi-spacing-s);
  --bsi-dropdown-header-padding-y: var(--bsi-spacing-xxs);
  --bsi-dropdown-inner-border-radius: var(--bsi-radius-smooth);
  --bsi-dropdown-item-padding-x: var(--bsi-spacing-s);
  --bsi-dropdown-item-padding-y: var(--bsi-spacing-xs);
  --bsi-dropdown-link-active-color: var(--bsi-color-text-primary-active);
  --bsi-dropdown-link-color: var(--bsi-color-text-primary);
  --bsi-dropdown-link-hover-color: var(--bsi-color-text-primary-hover);
  --bsi-dropdown-min-width: 10rem;
  --bsi-dropdown-notch-base-size: 1.125rem;
  --bsi-dropdown-notch-position-x: 20px;
  --bsi-dropdown-notch-position-y: -8px;
  --bsi-dropdown-padding-x: 0;
  --bsi-dropdown-padding-y: var(--bsi-spacing-xxs);
  --bsi-dropdown-spacer: 0.125rem;
  --bsi-dropdown-vertical-shift: 10px;
  --bsi-dropdown-zindex: 8;
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  z-index: var(--bsi-dropdown-zindex);
  display: none;
  min-width: var(--bsi-dropdown-min-width);
  margin: 0;
  padding: var(--bsi-dropdown-padding-y) var(--bsi-dropdown-padding-x);
  border: var(--bsi-dropdown-border-width) solid var(--bsi-dropdown-border-color);
  border-radius: 0 0 var(--bsi-dropdown-border-radius) var(--bsi-dropdown-border-radius);
  background-color: var(--bsi-dropdown-background);
  color: var(--bsi-dropdown-color);
  list-style: none;
  text-align: left;
  background-clip: padding-box;
  font-size: var(--bsi-dropdown-font-size);
  box-shadow: var(--bsi-dropdown-box-shadow);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bsi-dropdown-spacer);
}
.dropdown-menu.full-width {
  width: 100%;
}
.dropdown-menu.full-width .link-list li {
  display: inline-block;
  width: auto;
}
.dropdown-menu.full-width .link-list li:hover, .dropdown-menu.full-width .link-list li:focus {
  background: none;
  text-decoration: underline;
}
.dropdown-menu .link-list {
  margin-bottom: 0;
}
.dropdown-menu:before {
  position: absolute;
  top: var(--bsi-dropdown-notch-position-y);
  left: var(--bsi-dropdown-notch-position-x);
  content: "";
  width: var(--bsi-dropdown-notch-base-size);
  height: var(--bsi-dropdown-notch-base-size);
  border-radius: var(--bsi-dropdown-border-radius);
  background-color: var(--bsi-dropdown-background);
  transform: rotate(45deg);
}
.dropdown-menu[data-popper-placement=top-start] {
  border-radius: var(--bsi-dropdown-border-radius) var(--bsi-dropdown-border-radius) 0 0;
}
.dropdown-menu[data-popper-placement=top-start]:before {
  top: auto;
  bottom: var(--bsi-dropdown-notch-position-y);
}
.dropdown-menu[data-popper-placement=bottom-end]:before {
  right: calc(var(--bsi-dropdown-notch-position-x) / 2);
  left: auto;
}
.dropdown-menu.dark {
  --bsi-dropdown-text-color: var(--bsi-color-text-inverse);
  --bsi-dropdown-background: var(--bsi-color-background-primary-muted);
  --bsi-dropdown-link-color: var(--bsi-color-text-inverse);
  --bsi-dropdown-divider-bg: var(--bsi-color-border-subtle);
  --bsi-dropdown-link-active-color: var(--bsi-color-text-inverse);
  --bsi-dropdown-header-color: var(--bsi-color-text-inverse);
}
.dropdown-menu.dark:before {
  background-color: var(--bsi-dropdown-background);
}
.dropdown-menu.dark .link-list-heading {
  color: var(--bsi-color-text-inverse);
}
.dropdown-menu.dark .link-list span.divider {
  background: #2e465e;
}
.dropdown-menu.dark .link-list a span,
.dropdown-menu.dark .link-list a:hover span {
  color: var(--bsi-color-text-inverse);
}
.dropdown-menu.dark .link-list a.active span {
  text-decoration: underline;
}
.dropdown-menu.dark .link-list a.disabled span {
  color: hsla(var(--bsi-color-text-base), 0.35);
  cursor: not-allowed;
}
.dropdown-menu.show {
  display: block;
}
.dropdown-menu.show[data-popper-placement=bottom-start] {
  animation: dropdownFadeIn forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=top-start] {
  animation: dropdownFadeInTop forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=left-start] {
  animation: dropdownFadeInTop forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=left-start]:before {
  top: 20px;
  right: -6px;
  left: auto;
}
.dropdown-menu.show[data-popper-placement=right-start] {
  animation: dropdownFadeInTop forwards var(--bsi-dropdown-animation-speed);
}
.dropdown-menu.show[data-popper-placement=right-start]:before {
  top: 20px;
  left: -6px;
}

.dropdown-menu-start {
  --bsi-dropdown-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bsi-dropdown-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bsi-dropdown-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bsi-dropdown-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bsi-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bsi-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bsi-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bsi-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bsi-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item.list-item {
  width: auto;
  padding: var(--bsi-dropdown-item-padding-y) var(--bsi-dropdown-item-padding-x);
  border: 0;
  background-color: transparent;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
}
.dropdown-item.list-item:hover, .dropdown-item.list-item:focus {
  text-decoration: none;
}

.dropdown-header.link-list-heading {
  display: block;
  margin-bottom: 0;
  padding: var(--bsi-dropdown-header-padding-y) var(--bsi-dropdown-header-padding-x);
  color: var(--bsi-dropdown-header-color);
  font-size: var(--bsi-dropdown-header-font-size);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bsi-dropdown-item-padding-y) var(--bsi-dropdown-item-padding-x);
  color: var(--bsi-dropdown-link-color);
}

@keyframes dropdownFadeIn {
  0% {
    margin-top: 0;
    opacity: 0;
  }
  100% {
    margin-top: var(--bsi-dropdown-vertical-shift);
    opacity: 1;
  }
}
@keyframes dropdownFadeInTop {
  0% {
    margin-top: 0;
    opacity: 0;
  }
  100% {
    margin-top: calc(-1 * var(--bsi-dropdown-vertical-shift));
    opacity: 1;
  }
}
.dropdown.dropup .dropdown-toggle:after,
.btn-group.dropup .dropdown-toggle:after {
  display: none;
}
.dropdown.dropup .dropdown-toggle[aria-expanded=true] .icon-expand,
.btn-group.dropup .dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: scaleY(1);
}
.dropdown.dropup .dropdown-toggle .icon-expand,
.btn-group.dropup .dropdown-toggle .icon-expand {
  transform: scaleY(-1);
}
.dropdown.dropend .dropdown-toggle:after,
.btn-group.dropend .dropdown-toggle:after {
  display: none;
}
.dropdown.dropend .dropdown-toggle[aria-expanded=true] .icon-expand,
.btn-group.dropend .dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: rotate(90deg);
}
.dropdown.dropend .dropdown-toggle .icon-expand,
.btn-group.dropend .dropdown-toggle .icon-expand {
  transform: rotate(-90deg);
}
.dropdown.dropstart .dropdown-toggle:before,
.btn-group.dropstart .dropdown-toggle:before {
  display: none;
}
.dropdown.dropstart .dropdown-toggle[aria-expanded=true] .icon-expand,
.btn-group.dropstart .dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: rotate(-90deg);
}
.dropdown.dropstart .dropdown-toggle .icon-expand,
.btn-group.dropstart .dropdown-toggle .icon-expand {
  transform: rotate(90deg);
}

.btn-dropdown {
  --bsi-dropdown-button-color: var(--bsi-color-text-primary);
  --bsi-dropdown-button-padding: 10px;
  --bsi-dropdown-button-background: #fff;
  border-radius: 0;
  box-shadow: none;
  color: var(--bsi-dropdown-button-color);
}
@media (min-width: 992px) {
  .btn-dropdown {
    font-size: var(--bsi-label-font-size-l);
  }
}
.btn-dropdown:hover {
  --bsi-dropdown-button-color: var(--bsi-color-link-hover);
  text-decoration: underline;
}
.btn-dropdown:not(:disabled):active {
  box-shadow: none;
}

.btn-dropdown:after,
.dropdown-toggle:after {
  content: "";
  display: inline;
  width: auto;
  height: auto;
  margin: 0;
  border: none;
  vertical-align: bottom;
}
.btn-dropdown .icon-expand,
.dropdown-toggle .icon-expand {
  transition: transform var(--bsi-dropdown-animation-speed);
}
.btn-dropdown .icon.icon-xs,
.dropdown-toggle .icon.icon-xs {
  transform: translateY(-1px);
  transition: transform var(--bsi-dropdown-animation-speed);
}
.btn-dropdown[aria-expanded=true] .icon-expand,
.dropdown-toggle[aria-expanded=true] .icon-expand {
  transform: scaleY(-1);
}

.link-list-wrapper {
  --bsi-linklist-divider-size: 1px;
  --bsi-linklist-heading-color: var(--bsi-color-text-secondary);
  --bsi-linklist-heading-font-size: var(--bsi-heading-6-font-size);
  --bsi-linklist-item-font-size: var(--bsi-label-font-size);
  --bsi-linklist-item-line-height: var(--bsi-label-leading);
  --bsi-linklist-item-spacing: var(--bsi-spacing-xxs);
  --bsi-linklist-nested-spacing: var(--bsi-spacing-s);
}

/* stylelint-disable-next-line no-duplicate-selectors */
.link-list-wrapper .link-list-heading,
.link-list-wrapper h3 {
  margin-bottom: var(--bsi-spacing-xxs);
  color: var(--bsi-linklist-heading-color);
  font-size: var(--bsi-linklist-heading-font-size);
  font-weight: var(--bsi-heading-font-weight-weak);
  line-height: var(--bsi-heading-line-height);
}
.link-list-wrapper h3 {
  padding: 0 var(--bsi-spacing-m);
}
.link-list-wrapper ul {
  padding: 0;
  list-style-type: none;
}
.link-list-wrapper ul.link-sublist {
  padding-left: var(--bsi-linklist-nested-spacing);
}
.link-list-wrapper li span,
.link-list-wrapper .list-item {
  font-size: var(--bsi-linklist-item-font-size);
  line-height: var(--bsi-linklist-item-line-height);
}
.link-list-wrapper .list-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 1;
  padding-top: var(--bsi-linklist-item-spacing);
  padding-bottom: var(--bsi-linklist-item-spacing);
  text-decoration: none;
}
.link-list-wrapper .list-item.active span, .link-list-wrapper .list-item:hover:not(.disable) span {
  text-decoration: underline;
}
.link-list-wrapper .list-item.active span {
  color: var(--bsi-color-link-active);
}
.link-list-wrapper .list-item.active .icon {
  color: var(--bsi-color-icon-primary-active);
}
.link-list-wrapper .list-item:hover:not(.disabled) span {
  color: var(--bsi-color-link-hover);
}
.link-list-wrapper .list-item:hover:not(.disabled) .icon {
  fill: var(--bsi-icon-primary-hover);
}
.link-list-wrapper .list-item:hover:not(.disabled) .icon.icon-inverse {
  fill: var(--bsi-icon-inverse);
}
.link-list-wrapper .list-item.disabled {
  cursor: not-allowed;
}
.link-list-wrapper .list-item.disabled:hover span {
  text-decoration: none;
}
.link-list-wrapper .list-item.disabled span {
  color: var(--bsi-color-text-disabled);
}
.link-list-wrapper .list-item.disabled svg {
  fill: var(--bsi-icon-disabled);
}
.link-list-wrapper .list-item.disabled svg.secondary {
  fill: var(--bsi-icon-disabled);
}
.link-list-wrapper .list-item.medium,
.link-list-wrapper .list-item .list-item-title {
  font-weight: var(--bsi-font-weight-solid);
}
.link-list-wrapper .list-item.large {
  --bsi-linklist-item-font-size: var(--bsi-label-font-size-l);
}
.link-list-wrapper .list-item.avatar {
  display: flex;
  margin-bottom: var(--bsi-spacing-xxs);
}
.link-list-wrapper .list-item.avatar .avatar {
  display: block;
  margin-right: var(--bsi-spacing-s);
}
.link-list-wrapper .list-item.icon-right, .link-list-wrapper .list-item.icon-left {
  padding-right: 0;
  padding-left: 0;
}
.link-list-wrapper .list-item.icon-left .icon {
  left: 0;
  flex-shrink: 0;
  margin-right: var(--bsi-spacing-xxs);
}
.link-list-wrapper .list-item.icon-left p {
  width: 100%;
}
.link-list-wrapper .list-item.icon-right {
  width: 100%;
}
.link-list-wrapper .list-item.icon-right .list-item-title-icon-wrapper {
  justify-content: space-between;
}
.link-list-wrapper .list-item.right-icon .list-item-title-icon-wrapper {
  justify-content: space-between;
}
.link-list-wrapper .list-item.right-icon .icon {
  transition: transform var(--bsi-transition-instant);
}
.link-list-wrapper .list-item.right-icon .icon.secondary {
  color: var(--bsi-icon-secondary);
}
.link-list-wrapper .list-item[data-bs-toggle] .icon {
  transition: transform 0.3s;
}
.link-list-wrapper .list-item[aria-expanded=true] .icon {
  transform: rotate(180deg);
}
.link-list-wrapper .list-item .icon {
  display: inline-block;
  flex-shrink: 0;
}
.link-list-wrapper .list-item .list-item-title-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}
.link-list-wrapper .list-item .list-item-title-icon-wrapper .list-item-title {
  margin-right: var(--bsi-spacing-xxs);
}
.link-list-wrapper .list-item > p {
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}
.link-list-wrapper .list-item > span {
  display: inline-block;
  color: var(--bsi-color-link);
}
.link-list-wrapper .divider {
  display: block;
  height: var(--bsi-linklist-divider-size);
  margin: var(--bsi-spacing-xxs) 0;
  background: var(--bsi-color-border-subtle);
}
.link-list-wrapper .form-check {
  padding: 0 var(--bsi-spacing-m);
}

.multiline .list-item-title-icon-wrapper {
  margin-bottom: var(--bsi-spacing-3xs);
}
.multiline .list-item.icon-right .list-item-title-icon-wrapper {
  margin-right: 0;
}
.multiline .list-item-title {
  font-size: var(--bsi-label-font-size);
}
@media (min-width: 992px) {
  .multiline .list-item-title {
    font-size: var(--bsi-label-font-size-l);
  }
}
.multiline .list-item {
  display: block;
}
.multiline p {
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .link-list-wrapper ul li a.large.icon-left,
  .link-list-wrapper ul li a.large.icon-right {
    --bsi-linklist-item-spacing: var(--bsi-spacing-s);
  }
}
.dark,
.theme-dark {
  --bsi-linklist-heading-color: var(--bsi-color-text-inverse);
}
.dark .link-list-wrapper .list-item:not(.disabled) span,
.dark .link-list-wrapper .list-item:hover span,
.theme-dark .link-list-wrapper .list-item:not(.disabled) span,
.theme-dark .link-list-wrapper .list-item:hover span {
  color: var(--bsi-color-text-inverse);
}
.dark .link-list-wrapper .list-item.disabled,
.dark .link-list-wrapper .list-item.disabled span,
.theme-dark .link-list-wrapper .list-item.disabled,
.theme-dark .link-list-wrapper .list-item.disabled span {
  color: hsla(var(--bsi-color-text-base), 0.35);
}

.dropdown-menu {
  z-index: 11;
}
.dropdown-menu::before {
  content: none;
}
.dropdown-menu.dark {
  --bsi-dropdown-header-color: var(--bsi-color-text-inverse);
  --bsi-color-border-subtle: #2e465e;
}
.dropdown-menu .arrow {
  z-index: -1;
  width: var(--bsi-dropdown-notch-base-size);
  height: var(--bsi-dropdown-notch-base-size);
  border-radius: var(--bsi-dropdown-border-radius);
  background-color: var(--bsi-dropdown-background);
}

.link-list {
  margin-top: 0;
}

:host {
  position: relative;
  display: inline-block;
  --bsi-dropdown-animation-speed: 0.3s;
  --bsi-icon-default: currentColor;
}

it-button,
it-popover {
  display: inline-flex;
}

it-popover[placement=right-start] .dropdown-menu,
it-popover[placement=right] .dropdown-menu,
it-popover[placement=right-end] .dropdown-menu,
it-popover[placement=left-start] .dropdown-menu,
it-popover[placement=left] .dropdown-menu,
it-popover[placement=left-end] .dropdown-menu {
  border-radius: var(--bsi-dropdown-border-radius);
}

.dropdown-toggle .icon-expand.top {
  transform: scaleY(-1);
}
.dropdown-toggle .icon-expand.left {
  transform: rotate(90deg);
}
.dropdown-toggle .icon-expand.right {
  transform: rotate(-90deg);
}
.dropdown-toggle[it-aria-expanded] .icon-expand {
  transform: scaleY(-1);
}
.dropdown-toggle[it-aria-expanded] .icon-expand.top {
  transform: scaleY(1);
}
.dropdown-toggle[it-aria-expanded] .icon-expand.left {
  transform: rotate(-90deg);
}
.dropdown-toggle[it-aria-expanded] .icon-expand.right {
  transform: rotate(90deg);
}`;

// Base class without @customElement decorator for inheritance
class ItDropdownBase extends BaseComponent {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.variant = 'primary';
        this.alignment = 'bottom-start';
        this.dark = false;
        this.fullWidth = false;
        this.itRole = 'list';
        this.itAriaLabel = '';
        this.offset = null;
        this.noFlip = false;
        /** When true, hides the expand (caret) icon next to the trigger label. Used e.g. by the avatar "+N" group balloon. */
        this.hideExpandIcon = false;
        /** When true, centres the popover arrow on the trigger instead of the fixed notch position. Used by avatar dropdowns. */
        this.centerArrow = false;
        this._popoverOpen = false;
        this._buttonId = this.generateId('it-dropdown');
        this._menuId = this.generateId('it-dropdown-menu');
        this._ariaNav = new AriaKeyboardListController(this);
        this._onTriggerClick = () => {
            if (this.disabled)
                return;
            this._popoverOpen = !this._popoverOpen;
        };
        this._onPopoverOpen = () => {
            this._popoverOpen = true;
            this.setAttribute('data-it-aria-expanded', 'true');
        };
        this._onPopoverClose = () => {
            this._popoverOpen = false;
            this.setAttribute('data-it-aria-expanded', 'false');
        };
        this._onTabKeyDown = (event, items, active, currentIndex) => {
            function isTrigger(el) {
                return currentIndex === -1;
            }
            if (event.key === 'Tab') {
                if (isTrigger()) {
                    if (event.shiftKey)
                        this._popoverOpen = false;
                    return;
                }
                // if (event.shiftKey && currentIndex === -1) {
                //   // from the trigger item
                //   this._popoverOpen = false;
                // }
                if (!event.shiftKey && currentIndex === items.length - 1) {
                    // from the last item
                    this._popoverOpen = false;
                }
                if (active.ariaDisabled) {
                    // as of the day of this implementation, tabbing through disabled items doesn't work natively
                    // maybe because of some web components behavior
                    if (event.shiftKey) {
                        this._ariaNav.handleKeyDown(new KeyboardEvent('keydown', { ...event, key: 'ArrowUp' }));
                    }
                    else {
                        this._ariaNav.handleKeyDown(new KeyboardEvent('keydown', { ...event, key: 'ArrowDown' }));
                    }
                    if (!active.href)
                        event.preventDefault();
                }
                if (!active.href) {
                    // when the dropdown items don't have an href they are not natively tabbable, handle manually
                    if (event.shiftKey && currentIndex > 0) {
                        event.preventDefault();
                        this._ariaNav.handleKeyDown(new KeyboardEvent('keydown', { ...event, key: 'ArrowUp' }));
                    }
                    if (!event.shiftKey && currentIndex < items.length - 1) {
                        event.preventDefault();
                        this._ariaNav.handleKeyDown(new KeyboardEvent('keydown', { ...event, key: 'ArrowDown' }));
                    }
                    if (!event.shiftKey && currentIndex === items.length - 1) {
                        this._triggerEl?.dispatchEvent(new KeyboardEvent('keydown', { ...event }));
                    }
                }
            }
        };
        this._onKeyDown = (event) => {
            const items = this._menuItems.map((item) => item.getFocusableElement()).filter((el) => !!el);
            const active = this.getActiveElement();
            if (!active)
                return;
            const currentIndex = items.indexOf(active);
            // handle Tab keydown separately to anable overriding this bhv from consumer components that extend this.
            this._onTabKeyDown(event, items, active, currentIndex);
            const handle = () => {
                this._ariaNav.setConfig({
                    getItems: () => items,
                    setActive: (idx) => {
                        items[idx]?.focus();
                    },
                    closeMenu: () => {
                        this.addEventListener('it-popover-close', () => {
                            this._triggerEl?.focus();
                        }, { once: true, capture: true });
                        this._popoverOpen = false;
                    },
                    trigger: this._triggerEl,
                });
                this._ariaNav.handleKeyDown(event);
            };
            if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
                if (!this.disabled && !this._popoverOpen && currentIndex === -1) {
                    this.addEventListener('it-popover-open', handle, { once: true });
                    this._popoverOpen = true;
                    return;
                }
            }
            handle();
        };
        this._onDocumentClick = (event) => {
            // Use composedPath() instead of event.target: when this dropdown is nested inside
            // another shadow DOM host (e.g. it-toolbar-item), the target seen at the document
            // level is retargeted to that outer host, so `this.contains(event.target)` would
            // always be false and immediately close the dropdown right after opening it.
            if (this._popoverOpen && !event.composedPath().includes(this)) {
                this._popoverOpen = false;
            }
        };
    }
    get _triggerEl() {
        return this.shadowRoot?.getElementById(this._buttonId) ?? null;
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        // Ascolta i click fuori dal componente per chiudere il popover
        document.addEventListener('click', this._onDocumentClick, true);
    }
    disconnectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.disconnectedCallback();
        document.removeEventListener('click', this._onDocumentClick, true);
    }
    get _menuItems() {
        if (!this._slotEl)
            return [];
        return this._slotEl
            .assignedElements({ flatten: true })
            .filter((el) => el.tagName === 'IT-DROPDOWN-ITEM');
    }
    _setChildrenProperties() {
        for (const item of this._menuItems) {
            item.dark = this.dark;
            item.fullWidth = this.fullWidth;
            if (this.itRole === 'menu')
                item.itRole = 'menuitem';
            else if (this.itRole === 'listbox')
                item.itRole = 'option';
            else if (this.itRole === 'tree')
                item.itRole = 'treeitem';
            else if (this.itRole === 'list') {
                // set role to 'listitem' to fix axe tools alert, and force itRole to 'presentation' to avoid duplicate roles in the megamenu
                item.itRole = 'presentation';
                item.role = 'listitem';
            }
            else
                item.itRole = undefined;
        }
    }
    updated() {
        this._setChildrenProperties();
    }
    // https://github.com/primefaces/primeng/issues/14851 for conditional aria controls
    render() {
        return html `
      <it-popover
        placement=${this.alignment}
        @it-popover-open=${this._onPopoverOpen}
        @it-popover-close=${this._onPopoverClose}
        exportparts="focusable, icon, button, it-icon, it-button, dropdown-button, dropdown-icon-expand, popover-content"
        part="dropdown-popover"
        ?open=${this._popoverOpen}
        offset=${ifDefined(this.offset || undefined)}
        ?no-flip=${this.noFlip}
        ?center-arrow=${this.centerArrow}
        controlled
      >
        <it-button
          id=${this._buttonId}
          slot="trigger"
          ?disabled="${this.disabled}"
          type="button"
          variant=${ifDefined(this.variant)}
          size=${ifDefined(this.size)}
          @click=${this._onTriggerClick}
          @keydown=${{ handleEvent: this._onKeyDown, capture: true }}
          class="dropdown-toggle"
          it-aria-label=${ifDefined(this.itAriaLabel ? this.itAriaLabel : undefined)}
          exportparts="focusable, button, icon, it-icon"
          part="dropdown-button"
          it-aria-haspopup="${this.itRole === 'list' ? 'true' : this.itRole}"
          it-aria-controls=${this._popoverOpen ? this._menuId : nothing}
        >
          ${this.alignment.startsWith('left') && !this.hideExpandIcon
            ? html `<it-icon
                name="it-expand"
                class="icon-expand left"
                size="sm"
                exportparts="icon"
                part="dropdown-icon-expand"
              ></it-icon>`
            : ''}

          <slot name="label">${this.label}</slot>
          ${!this.alignment.startsWith('left') && !this.hideExpandIcon
            ? html `<it-icon
                name="it-expand"
                class=${this.composeClass('icon-expand', {
                right: this.alignment.startsWith('right'),
                top: this.alignment.startsWith('top'),
            })}
                exportparts="icon"
                part="dropdown-icon-expand"
                size="sm"
              ></it-icon>`
            : ''}
        </it-button>
        <div
          slot="content"
          part="popover-content"
          class="${this.composeClass('dropdown-menu', {
            show: this._popoverOpen,
            dark: this.dark,
            'full-width': this.fullWidth,
        })}"
          aria-labelledby=${this._buttonId}
        >
          <div class="link-list-wrapper">
            <slot name="header"></slot>
            <ul
              id=${this._menuId}
              class="link-list"
              role=${ifDefined(this.itRole !== 'list' ? this.itRole : undefined)}
              @keydown=${{ handleEvent: this._onKeyDown, capture: true }}
              aria-orientation=${ifDefined(this.fullWidth ? 'horizontal' : undefined)}
            >
              <slot @slotchange=${this._setChildrenProperties}></slot>
            </ul>
          </div>
        </div>
      </it-popover>
    `;
    }
}
ItDropdownBase.styles = styles;
ItDropdownBase.shadowRootOptions = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItDropdownBase.prototype, "label", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItDropdownBase.prototype, "disabled", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItDropdownBase.prototype, "size", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItDropdownBase.prototype, "variant", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], ItDropdownBase.prototype, "alignment", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], ItDropdownBase.prototype, "dark", void 0);
__decorate([
    property({ type: Boolean, attribute: 'full-width', reflect: true }),
    __metadata("design:type", Object)
], ItDropdownBase.prototype, "fullWidth", void 0);
__decorate([
    property({ type: String, attribute: 'it-role' }),
    __metadata("design:type", String)
], ItDropdownBase.prototype, "itRole", void 0);
__decorate([
    property({ type: String, attribute: 'it-aria-label' }),
    __metadata("design:type", String)
], ItDropdownBase.prototype, "itAriaLabel", void 0);
__decorate([
    property({ type: Number, attribute: 'offset' }),
    __metadata("design:type", Object)
], ItDropdownBase.prototype, "offset", void 0);
__decorate([
    property({ type: Boolean, attribute: 'no-flip' }),
    __metadata("design:type", Boolean)
], ItDropdownBase.prototype, "noFlip", void 0);
__decorate([
    property({ type: Boolean, attribute: 'hide-expand-icon', reflect: true }),
    __metadata("design:type", Boolean)
], ItDropdownBase.prototype, "hideExpandIcon", void 0);
__decorate([
    property({ type: Boolean, attribute: 'center-arrow', reflect: true }),
    __metadata("design:type", Boolean)
], ItDropdownBase.prototype, "centerArrow", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], ItDropdownBase.prototype, "_popoverOpen", void 0);
__decorate([
    query('slot:not([name])'),
    __metadata("design:type", HTMLSlotElement)
], ItDropdownBase.prototype, "_slotEl", void 0);

export { ItDropdownBase };
//# sourceMappingURL=it-dropdown-base.js.map
